export default "__VITE_ASSET__a0e94f7c__"